export default __webpack_public_path__ + "39c29e2137172913c189e3ecf8bab1f5.png";